import { render, staticRenderFns } from "./ModalInput.vue?vue&type=template&id=6d6d2a6f&"
import script from "./ModalInput.vue?vue&type=script&lang=js&"
export * from "./ModalInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports